//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { GenericInvoiceInputItem } from './GenericInvoiceInputItem';
import { ReportType } from './Enums';

export class InvoiceChargesInputItem extends GenericInvoiceInputItem {
    BCCTeacher: boolean = false;
    RecipientParentID: string | null = null;
    FamilyID: string | null = null;
    TransactionIDs: string[] = [];
    readonly Type: ReportType = ReportType.InvoiceByCharge;

    constructor(initializer?: Partial<Omit<InvoiceChargesInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "InvoiceChargesInputItem";
}
